/**
 * FEEDBACK WIDGET — CONTEXT REGISTRY (TICKET-CRM-14)
 * Remplace la capture des stores zustand de benevoles : le CRM n'a pas de
 * stores globaux, les composants enregistrent des providers de contexte
 * léger (rôle user, filtres actifs…). Contrainte spec §6 : ne jamais exposer
 * de champs nominatifs — identifiants techniques uniquement.
 */

type ContextProvider = () => unknown;

const providers = new Map<string, ContextProvider>();

export function registerContextProvider(name: string, provider: ContextProvider): void {
  providers.set(name, provider);
}

export function unregisterContextProvider(name: string): void {
  providers.delete(name);
}

export function collectContext(): Record<string, unknown> {
  const context: Record<string, unknown> = {};
  for (const [name, provider] of providers) {
    try {
      context[name] = provider();
    } catch {
      context[name] = 'provider_error';
    }
  }
  return context;
}
